import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PreviewBanner from "@/components/PreviewBanner";

import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import KioskPage from "@/pages/KioskPage";
import DashboardLayout from "@/pages/DashboardLayout";
import DashboardHome from "@/pages/DashboardHome";
import EmployeesPage from "@/pages/EmployeesPage";
import AttendancePage from "@/pages/AttendancePage";
import ReportsPage from "@/pages/ReportsPage";
import ExpensesPage from "@/pages/ExpensesPage";
import PaymentsPage from "@/pages/PaymentsPage";
import LeavesPage from "@/pages/LeavesPage";
import InventoryPage from "@/pages/InventoryPage";
import RecipesPage from "@/pages/RecipesPage";
import MenuMarginPage from "@/pages/MenuMarginPage";
import PartyBookingsPage from "@/pages/PartyBookingsPage";
import DailySalesPage from "@/pages/DailySalesPage";
import BreakHistoryPage from "@/pages/BreakHistoryPage";
import DutyChartPage from "@/pages/DutyChartPage";
import TasksPage from "@/pages/TasksPage";
import SettingsPage from "@/pages/SettingsPage";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-muted-foreground font-serif text-xl">Loading…</div>
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <PreviewBanner />
          <Routes>
            <Route path="/" element={<Navigate to="/kiosk" replace />} />
            <Route path="/kiosk" element={<KioskPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<Navigate to="/login" replace />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/dashboard"
              element={
                <Protected>
                  <DashboardLayout />
                </Protected>
              }
            >
              <Route index element={<DashboardHome />} />
              <Route path="employees" element={<EmployeesPage />} />
              <Route path="attendance" element={<AttendancePage />} />
              <Route path="reports" element={<ReportsPage />} />
              <Route path="expenses" element={<ExpensesPage />} />
              <Route path="payments" element={<PaymentsPage />} />
              <Route path="leaves" element={<LeavesPage />} />
              <Route path="inventory" element={<InventoryPage />} />
              <Route path="recipes" element={<RecipesPage />} />
              <Route path="menu-margin" element={<MenuMarginPage />} />
              <Route path="parties" element={<PartyBookingsPage />} />
              <Route path="sales" element={<DailySalesPage />} />
              <Route path="breaks" element={<BreakHistoryPage />} />
              <Route path="duty" element={<DutyChartPage />} />
              <Route path="tasks" element={<TasksPage />} />
              <Route path="settings" element={<SettingsPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
